module.exports = __webpack_public_path__ + "img/3.ae0773b0.jpg";